import { addDays } from 'date-fns'

/**
 Calculates which date easter falls on for a given year
 https://www.irt.org/articles/js052/index.htm
*/
export const easterDate = (year: number) => {
  var C = Math.floor(year / 100)
  var N = year - 19 * Math.floor(year / 19)
  var K = Math.floor((C - 17) / 25)
  var I = C - Math.floor(C / 4) - Math.floor((C - K) / 3) + 19 * N + 15
  I = I - 30 * Math.floor(I / 30)
  I =
    I -
    Math.floor(I / 28) *
      (1 -
        Math.floor(I / 28) *
          Math.floor(29 / (I + 1)) *
          Math.floor((21 - N) / 11))
  var J = year + Math.floor(year / 4) + I + 2 - C + Math.floor(C / 4)
  J = J - 7 * Math.floor(J / 7)
  var L = I - J
  var month = 3 + Math.floor((L + 40) / 44)
  var day = L + 28 - 31 * Math.floor(month / 4)

  return new Date(Date.UTC(year, month - 1, day))
}

export const getNationalHolidays = (date: Date) => {
  const year = date.getUTCFullYear()
  const easter = easterDate(year)

  const nationalHolidays: [Date, string][] = [
    [new Date(Date.UTC(year, 0, 1)), 'an Neujahr'],
    [addDays(easter, -2), 'an Karfreitag'],
    [addDays(easter, 1), 'an Ostermontag'],
    [new Date(Date.UTC(year, 4, 1)), 'am Tag der Arbeit'],
    [addDays(easter, 39), 'an Christi Himmelfahrt'],
    [addDays(easter, 50), 'an Pfingstmontag'],
    [new Date(Date.UTC(year, 9, 3)), 'am Tag der Deutschen Einheit'],
    [new Date(Date.UTC(year, 11, 25)), 'am ersten Weihnachtstag'],
    [new Date(Date.UTC(year, 11, 26)), 'am zweiten Weihnachtstag'],
  ]

  return nationalHolidays
}
